import React from 'react'

export default () => <div style={{ display: 'table', clear: 'both' }} />


// WEBPACK FOOTER //
// ./src/utils/Clearfix.js